import { action, observable } from "mobx"

export abstract class PageTab {
  abstract readonly id: string
  abstract readonly label: string
  abstract readonly hrefTemplate: string

  isActive = observable.box(false)

  setActive = action((active: boolean): void => {
    this.isActive.set(active)
  })

  generateHref(params: Record<string, string>): string {
    let href = this.hrefTemplate

    // Replace template variables with actual values
    Object.entries(params).forEach(([key, value]) => {
      href = href.replace(`{${key}}`, value)
    })

    return href
  }
}
